import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";

function AllPush() {
  return (
    <>
      <Sidebar openItem="all-advertise" activeItem="add-advertise-push" />

      <div className="content-wrapper">
        <TitleBar title="تبلیغات پوش" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div>
                <div className="alert alert-info">
                  <span className="pl-3">
                    <i className="fa fa-info"></i>
                  </span>
                  <span>این بخش به زودی پیاده سازی خواهد شد</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllPush;
